export const language = {
  CHOOSE_LOCATION_TITLE: 'Chọn chi nhánh',
  CHOOSE_DATETIME_TITLE: 'Bạn muốn check in vào thời gian nào?',
  BRANCH: 'Chi nhánh',
  GENERIC_ERROR: 'Đã có lỗi xảy ra. Vui lòng thử lại hoặc liên hệ nhân viên hỗ trợ.',
  SCAN_ERROR: 'Đã có lỗi xảy ra khi xử lý ảnh chụp CCCD. Vui lòng chụp lại hoặc liên hệ lễ tân để được hỗ trợ',
  UPDATE: 'Tìm phòng',
}

export const colors = {
  // primary: '#A63231',
  primary: '#8B0404',
  secondary: '#F3E6E6',
  primaryDark: '#8B0404',
  background: '#e8e8e8',
  backgroundHover: '#E0B324',
  backgroundSuccess: '#d1e7dd',
  borderSuccess: '#a3cfbb',
}

export const screens = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px',
}

export const ICON_HEIGHT = '1em'

export const DateTimeFormats = {
  DEFAULT: 'HH:mm, dd/MM/yyyy',
  FULL: 'HH:mm, cccc dd/MM/yyyy',
}

export const LOW_AVAILABLE_ROOM_WARNING = 2

export const TIME_INTERVAL_MINUTES = 30

export const MIN_HOURS = 1
export const MAX_HOURS = 8
export const DEFAULT_HOURS = 2
export const MAX_NIGHTS = 30

export const PHONE_REGEX = /^(84|0[3|5|7|8|9])+([0-9]{8})$/
export const PHONE_CHARS = /[0-9]/

export const OVERNIGHT_START_HOUR = 22
export const OVERNIGHT_END_HOUR = 8
export const DAY_CHECKIN_HOUR = 14

export const enum PaymentMethod {
  CheckIn = 'checkin',
  VNPAY_BankTransfer = 'VNPAY_BankTransfer',
  VNPAY_QR = 'VNPAY_QR',
  VNPAY_IntCard = 'VNPAY_IntCard',
  VietQR_Cake_Email = 'VietQR_Cake_Email',
  VietQR_Timo_Email = 'VietQR_Timo_Email',
  VietQR_VietinBank = 'VietQR_VietinBank',
}

export const CARD_HEIGHT = '15rem'
export const CARD_WIDTH = '25rem'
